/* eslint-disable */
import axios from 'axios'
import { lang } from '@/lang'
import qs from 'qs'
import { Notification, MessageBox, Message } from 'element-ui'
import { utilCookies } from '@/util/cookies'
import storejs from 'storejs'
import { status } from 'nprogress'
// axios实例
const axiosInstance = axios.create({
  baseURL: storejs.get('base_api') || process.env.VUE_APP_BASE_API,
  timeout: 20000,
  paramsSerializer(params) {
    return qs.stringify(params, {
      encode: true
    })
  }
})
// 错误提示
const errorNotice = message => Notification.error({ message, duration: 5000 })
const errorMessage = message => Message.error({ message, duration: 3000 })

// 请求拦截
axiosInstance.interceptors.request.use(
  config => {
    if (config.url) {
      return config
    }
    throw new axios.Cancel()
  },
  error => {
    errorNotice(error.message)
    return Promise.reject(error)
  }
)

// 响应拦截
axiosInstance.interceptors.response.use(
  response => {
    if (response.data) {
      if (
        response.data.code !== 1 &&
        response.config.url !== '/auth/qr/status' &&
        response.config.responseType !== 'blob'
      ) {
        if (response.data.code === 2003) {
          errorMessage(response.data.message)
          // code 为2003 说明该账户未注册，跳转注册页面
          const hash = window.location.hash
          const href = window.location.href
          window.location.href = href.replace(hash, '#/register/index')
        } else if (response.data.code === 2011) {
          // code 为2011 说明该用户为离职状态，不允许登录，直接跳转登录页面
          MessageBox.confirm(response.data.message, '', {
            confirmButtonText: lang.t('submit_btn'),
            center: true,
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          })
            .then(() => {
              utilCookies.removeToken()
              window.location.reload()
            })
            .catch(() => {})
        } else {
          // 登录相关接口使用Message
          if (response.config.errorMessage) {
            errorMessage(response.data.message)
          } else {
            errorNotice(response.data.message)
          }
          return Promise.reject(response.data)
        }
      }
      return response.data
    }
  },
  error => {
    let message = ''
    const status = error.response?.status
    if (error.response) {
      if (status === 401) {
        message = lang.t('15c93583')
        utilCookies.removeToken()
        window.location.reload()
      } else if (status === 403) {
        message = lang.t('5c935839')
      } else if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else if (error.response.data && error.response.data instanceof Blob) {
        const reader = new FileReader()
        reader.addEventListener('loadend', e => {
          const text = e.srcElement.result
          message = JSON.parse(text).message
        })
        reader.readAsText(error.response.data)
      } else {
        message = `server response error code ${status}`
      }
    } else {
      message = error.message
    }
    status !== 401 && errorNotice(message)
    return Promise.reject(error)
  }
)

const timeZone = function () {
  const off = Math.abs(new Date().getTimezoneOffset() / 60)
  const end = off.toFixed(2).split('.')
  return `+${end[0]}:${end[1]}`
}

export const baseHeaders = () => ({
  Authorization: 'Bearer ' + utilCookies.getToken(),
  'Accept-Language': lang.i18n.locale,
  'X-Token': utilCookies.getCompanyToken(),
  'X-Timezone': timeZone()
})

// 封装axiosRequest
export const axiosRequest = option => {
  const headers = baseHeaders()
  headers.Authorization = 'Bearer ' + utilCookies.getToken()
  const config = JSON.parse(JSON.stringify(option))
  config.method === undefined && (config.method = 'post')
  config.hasBaseParamsData === undefined && (config.hasBaseParamsData = true)
  // 公共请求头

  // 添加公共请求头
  config.headers = Object.assign({}, headers, config.headers)
  return axiosInstance.request(config)
}
